const getLDUser = function(userID, lenderName) {
  // Mirror the lender-frontend LD context shape (helpers/ldHelpers getLDContext): flat
  // attributes with lender/lender_name (the lender NAME). Per-lender flags are targeted by
  // the lender name attribute — the identifier the backend context (get_value) also carries
  // consistently for both Lender and LenderUser (there is no lender_id attribute by convention).
  return {
    kind: 'user',
    key: userID,
    type: 'LENDER',
    lender: lenderName,
    lender_name: lenderName,
  }
}

export { getLDUser }
